const styles = {
  paddingX: "sm:px-16 px-4",
  paddingY: "sm:py-16 py-4",
  padding: "sm:px-16 px-4 sm:py-16 py-10",

  heroHeadText:
    "font-black text-white lg:text-[90px] sm:text-[70px] xs:text-[60px] text-[50px] lg:leading-[98px] mt-2",
  heroSubText:
    "text-[#dfd9ff] font-medium lg:text-[30px] sm:text-[26px] xs:text-[20px] text-[30px] py-2  lg:leading-[40px]",

  sectionHeadText:
    "text-white font-black md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px]",

  // sectionHeadText:
  //   "text-white font-black md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px]",

  sectionSubText:
    "sm:text-[18px] text-[14px] text-secondary uppercase tracking-wider",
};

export { styles };
